import { connect } from "react-redux";
import { getHeaderDiscount } from "shared/store/app/selectors";
import Discount from "./Discount";

const mapStateToProps = (store: any) => ({
    discount: getHeaderDiscount(store),
});

export default connect(
    mapStateToProps,
    {}
)(Discount);
